<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { base64ToBlob } from '@/helpers/base64ToBlob';
import Swal from "sweetalert2"

export default {
    components: {
        VueCropper,
    },
    data() {
        return {
            imgSrc: '',
            cropImg: '',
            data: null,
        };
    },
    methods: {
        handleModalShown() {
            if (!this.imgSrc) this.showFileChooser()
        },
        cropImage() {
            // get image data for post processing, e.g. upload or setting image src
            this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
            const blobImage = base64ToBlob(this.cropImg)
            this.$emit('cropedImage', blobImage);
            this.$bvModal.hide('isUploadImage')
        },
        setImage(e) {
            const file = e.target.files[0];

            if (file.type.indexOf('image/') === -1) {
                Swal.fire({
                    icon: "warning",
                    title: "Por favor, seleccione un archivo de imagen",
                    showConfirmButton: false,
                    timer: 4500
                });
                return;
            }

            if (typeof FileReader === 'function') {
                const reader = new FileReader();

                reader.onload = (event) => {
                    this.imgSrc = event.target.result;
                    // rebuild cropperjs with the updated source
                    this.$refs.cropper.replace(event.target.result);
                };

                reader.readAsDataURL(file);
            } else {
                Swal.fire({
                    icon: "warning",
                    title: "API de FileReader no compatible",
                    showConfirmButton: false,
                    timer: 4500
                });
            }
        },
        showFileChooser() {
            this.$refs.input.click();
        },
    },
};
</script>
<template>
    <b-modal id="isUploadImage" centered size="lg" hide-footer="true" @shown="handleModalShown">
        <input ref="input" type="file" name="image" accept="image/*" @change="setImage" />
        <section>
            <div class="img-cropper" v-if="imgSrc">
                <vue-cropper ref="cropper" :aspect-ratio="4 / 3" :src="imgSrc" preview=".preview" />
            </div>
            <div class="actions">
                <b-button href="#" variant="success" class="btn-img" @click.prevent="showFileChooser">
                    Cambiar imagen
                </b-button>
                <b-button href="#" variant="success" class="btn-img" @click.prevent="cropImage">
                    Aceptar
                </b-button>
            </div>

        </section>
    </b-modal>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/components/uploadImage';
</style>